/**
 * Milliseconds since epoch for catalog sorting, or null for Go zero / invalid dates.
 */
export function replayDateSortKey(dateInput) {
  const date = new Date(dateInput);
  const t = date.getTime();
  if (Number.isNaN(t) || date.getUTCFullYear() <= 1) {
    return null;
  }
  return t;
}

/**
 * Compare two catalog dates. Invalid/zero dates sort first when desc (page 1), last when asc.
 */
export function compareReplayDates(aDate, bDate, sortOrder = 'desc') {
  const ka = replayDateSortKey(aDate);
  const kb = replayDateSortKey(bDate);
  if (ka === null && kb === null) return 0;
  if (ka === null) return sortOrder === 'desc' ? -1 : 1;
  if (kb === null) return sortOrder === 'desc' ? 1 : -1;
  const comparison = ka - kb;
  return sortOrder === 'asc' ? comparison : -comparison;
}
